/**
 * Component: Example script
 * ------------------------------------------------------------------------------
 * An example file that contains scripts to function.
 *
 * @namespace cartDcode
 */
import {on} from '../helpers/utils';

/**
 * DOM selectors.
 */
const selectors = {
  cartContainer: '[js-cart="container"]',
  dCodeInput: '#dcodeInput',
  footerForm: '.cart-table-aside__footer',
};

/**
 * Create a new example object.
 * @param {object} config - Settings object defined when instantiating.
 */
export default () => {

  /**
   * DOM node selectors.
   */
  const nodeSelectors = {
    cartContainer: document.querySelector(selectors.cartContainer),
    footerForm: document.querySelector(selectors.footerForm),
  };
  let interval = true;

  /**
   * Check if the Dcode field has been created yet
   */
  function checkSelector() {
    if (document.querySelector(selectors.dCodeInput) === null) {
      return;
    }

    nodeSelectors.dCodeInput = document.querySelector(selectors.dCodeInput);
    setEventListeners();
    window.clearInterval(interval);
  }

  /**
   * Initialise component.
   */
  function init() {
    interval = window.setInterval(checkSelector, 50);
  }

  /**
   * Set trigger listeners.
   */
  function setEventListeners() {
    on('focus', nodeSelectors.dCodeInput, () => {
      nodeSelectors.footerForm.classList.add('hidden');
    });

    on('focusout', nodeSelectors.dCodeInput, () => {
      nodeSelectors.footerForm.classList.remove('hidden');
    });

    on('keypress', nodeSelectors.cartContainer, (event) => {
      setTimeout(() => {
        if (event.keyCode !== 13 || document.activeElement !== nodeSelectors.dCodeInput) {
          return;
        }

        console.log('ciao')
        nodeSelectors.dCodeInput.blur();
      }, 500);
    })
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init,
  });
};
